import { User } from 'oidc-client';

export const UserHelper = {
	getNumberFromUserProfile(user: User | undefined, propertyName: string) {
		if (user !== undefined && propertyName in user.profile && !isNaN(user.profile[propertyName])) {
			return Number(user.profile[propertyName]);
		}
		return undefined;
	},
};
